export type CalendarViewType = 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay';

export const enum CalendarViewTypes {
  dayGridMonth = 'dayGridMonth',
  timeGridWeek = 'timeGridWeek',
  timeGridDay = 'timeGridDay',
}

export const enum CalendarEditView {
  recurringHours = 'recurringHours',
  specificDate = 'specificDate'
}
